import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupTreeAssigmentServiceConfig = {
  name: "GroupTreeAssigment",
  annotations: []
} as ServiceConfig;